// @flow
import React, { Component, createRef, Fragment } from 'react';
import PropTypes from 'prop-types';
import { Helmet } from 'react-helmet';
import { defineMessages, FormattedMessage, intlShape } from 'react-intl';
import classNames from 'classnames/bind';

import commonStyle from '../../PreferencesViewCommon.scss';
import boxStyle from '../../../../assets/styles/box.scss';
import inputStyle from '../../../../assets/styles/input.scss';
import style from './Referral.scss';
import gift from '../../../../assets/img/gift.png';
import formStyle from '../../../../assets/styles/form.scss';
import buttonStyle from '../../../../assets/styles/button.scss';
import fb from '../../../../assets/img/referral/Facebook.png';
import twitter from '../../../../assets/img/referral/Twitter.png';
import mail from '../../../../assets/img/referral/Mail.png';

import type { User } from '../../../../entities';

type Props = {
  +user?: User;
};

type State = {
  buttonClicked: boolean;
};

const messages = defineMessages({
  title: {
    id: 'preferences.referral.document.title',
  },
  description: {
    id: 'preferences.referral.document.description',
  },
});

const buildMessage = (code: string) =>
  `¡Te regalo 20% de descuento en los gastos de importación de tu primera compra en Qempo con mi cupón ${code}! ` +
  'Tú también puedes comprar lo que necesites de Estados Unidos y olvidarte de trámites';


export default class Referral extends Component<Props, State> {
  inputRef = createRef();
  state = {
    buttonClicked: false,
  };

  handleClick = () => {
    if (this.inputRef.current instanceof HTMLInputElement) {
      this.inputRef.current.select();
      document.execCommand('copy');
      this.setState({
        buttonClicked: true,
      });
    }
  };

  handleClickFBSharedDialog = (code: string) => {
    const message = buildMessage(code);
    if (!(window: any).FB) return;
    (window: any).FB.ui({
      method: 'share',
      href: 'https://www.qempo.com.pe',
      quote: message,
    }, (response) => console.log(response));
  };

  handleClickTwitterShare = (code: string) => {
    const message = buildMessage(code);
    const url = `https://twitter.com/intent/tweet?text=${encodeURIComponent(message)}`;
    const width = 550;
    const height = 500;
    const options = `height=${height},width=${width},resizable=yes,toolbar=no,menubar=no,location=no,directories=no,status=yes`;
    window.open(url, 'popUpWindow', options);
  };

  handleClickMailShare = (code: string) => {
    const message = buildMessage(code);
    const subject = '¡20% de descuento en los gastos de importación de tu primera compra en Qempo!';
    const mailto_link = `mailto:?to=&subject=${subject}&body=${message}`;
    const win = window.open(mailto_link, 'emailWindow');
    if (win && win.open && !win.closed) win.close();
  };

  render() {
    const { user } = this.props;
    const { buttonClicked } = this.state;
    const code = !!user ? user.referralCoupon : '';

    const buttonLabelIntl = buttonClicked ? 'preferences.referral.code.copied' : 'preferences.referral.code.copy';

    return <Fragment>
      <Helmet key="helmet">
        <title>{this.context.intl.formatMessage(messages.title)}</title>
        <meta name="description" content={this.context.intl.formatMessage(messages.description)}/>
      </Helmet>
      <section key="referral" className={classNames(boxStyle.box, commonStyle.contentWrap)}>
        <article className={style.referralWrap}>
          <FormattedMessage id="preferences.referral.title">{
            txt => <h2 className={classNames(boxStyle.boxTitle, style.title)}>{txt}</h2>
          }</FormattedMessage>
          <article className={style.subtitleWrap}>
            <div className={style.imageWrap}>
              <img src={gift} alt="gift"/>
            </div>
            <div className={style.textWrap}>
              <FormattedMessage id="preferences.referral.subtitle">{
                txt => <p className={boxStyle.subtitle}>{txt}</p>
              }</FormattedMessage>
            </div>
          </article>
          <article className={classNames(formStyle.formWrap, style.codeWrap)}>
            <section className={formStyle.row}>
              <article className={formStyle.col}>
                <FormattedMessage id="preferences.referral.code.label">{
                  txt => <label className={formStyle.label}>{txt}:</label>
                }</FormattedMessage>
                <div className={style.couponCode}>
                  <input type="text"
                         name="coupon"
                         readOnly
                         value={code}
                         ref={this.inputRef}
                         className={classNames(inputStyle.input)}/>
                  <FormattedMessage id={buttonLabelIntl}>{
                    txt => <button className={classNames(buttonStyle.btn, buttonStyle.lightBlue)}
                                   onClick={this.handleClick}>{txt}</button>
                  }</FormattedMessage>
                </div>
              </article>
            </section>
            <section className={classNames(formStyle.row, style.socialWrap)}>
              <FormattedMessage id="preferences.referral.share">{
                txt => <h2 className={classNames(boxStyle.boxTitle, style.title, style.share)}>{txt}</h2>
              }</FormattedMessage>
              <img src={fb}
                   onClick={_ => this.handleClickFBSharedDialog(code)}
                   alt="fb"/>
              <img src={twitter}
                   onClick={_ => this.handleClickTwitterShare(code)}
                   alt="twitter"/>
              <img src={mail}
                   onClick={_ => this.handleClickMailShare(code)}
                   alt="mail"/>
            </section>
          </article>
          <section className={style.terms}>
            <FormattedMessage id="bonusesModal.terms">{
              txt => <a target="_blank"
                        href="https://help.qempo.com/article/753ns7hwy5-c-mo-gano-dinero-invitando-a-mis-amigos">{txt}</a>
            }</FormattedMessage>
          </section>
        </article>
      </section>
    </Fragment>;
  }
}

Referral.propTypes = {
  user: PropTypes.object,
};

Referral.contextTypes = {
  intl: intlShape,
};



// WEBPACK FOOTER //
// ./src/modules/preferences/referral/components/Referral.jsx